import React from 'react';
import { FormattedMessage } from '../Intl';

import './HeadLine.less';

const CNAME = 'HeadLine';

const HeadLine = () => (
  <h1 className={CNAME}>
    <FormattedMessage id="home.headline.aWholeVacation" defaultMessage={'Book beach houses, cabins,# condos and more, worldwide'}>
      {title => title.split('#').map((text, index) => <span key={index} className={`${CNAME}__text`}>{text.trim()}</span>)}
    </FormattedMessage>
  </h1>
);

export default HeadLine;



// WEBPACK FOOTER //
// ./src/universal/components/HeadLine/HeadLine.js